import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
export function Kontakt() {
  return <div className="min-h-screen bg-weiss flex flex-col" data-id="element-257">
      <Navigation data-id="element-258" />
      <main className="flex-grow flex items-center justify-center pt-32 pb-16" data-id="element-259">
        <h1 className="text-5xl md:text-7xl font-heading text-schwarz text-center" data-id="element-260">
          Kontakt & Termine
        </h1>
      </main>
      <Footer data-id="element-261" />
    </div>;
}